"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var react_1 = require('react');
var RaisedButton_1 = require('material-ui/RaisedButton');
var Table_1 = require('material-ui/Table');
var firebase = require('firebase');
var AutoComplete_1 = require('material-ui/AutoComplete');
var Dialog_1 = require('material-ui/Dialog');
var FlatButton_1 = require('material-ui/FlatButton');
var Paper_1 = require('material-ui/Paper');
var TextField_1 = require('material-ui/TextField');
var AppBar_1 = require('material-ui/AppBar');
var pokemon_1 = require('../pokemon');
require('core-js/fn/set');
require('core-js/fn/array/from');
require('./trader.scss');
var TraderApp = (function (_super) {
    __extends(TraderApp, _super);
    function TraderApp() {
        _super.call(this);
        this.pokemon = pokemon_1.pokemon;
        this.state = {
            listings: [],
            pokemon: '',
            zip: '',
            add: false
        };
    }
    TraderApp.prototype.componentWillMount = function () {
        var _this = this;
        this.ref = firebase.database().ref('listings');
        this.ref.on('value', function (snapshot) {
            var items = [];
            snapshot.forEach(function (child) {
                var item = child.val();
                item['.key'] = child.key;
                items.push(item);
                return false;
            });
            _this.setState({
                listings: items
            });
        });
    };
    TraderApp.prototype.componentWillUnmount = function () {
        this.ref.off();
    };
    TraderApp.prototype.updateSearchPokemon = function (pokemon) {
        this.setState({
            pokemon: pokemon
        });
    };
    TraderApp.prototype.updateSearchZip = function (zip) {
        this.setState({
            zip: zip
        });
    };
    TraderApp.prototype.setOpen = function (open) {
        this.setState({
            add: open
        });
    };
    TraderApp.prototype.updateHave = function (have) {
        this.setState({
            addHave: this.pokemon.map[have].id
        });
    };
    TraderApp.prototype.updateWant = function (want) {
        this.setState({
            addWant: this.pokemon.map[want].id
        });
    };
    TraderApp.prototype.updateUser = function (event) {
        var target = event.target;
        var input = target;
        this.setState({
            addUser: input.value
        });
    };
    TraderApp.prototype.updateZip = function (event) {
        var target = event.target;
        var input = target;
        this.setState({
            addZip: +input.value
        });
    };
    TraderApp.prototype.updateNotes = function (event) {
        var target = event.target;
        var input = target;
        this.setState({
            addNotes: input.value
        });
    };
    TraderApp.prototype.simplifyString = function (str) {
        return str.trim().toLowerCase();
    };
    TraderApp.prototype.simplifyContains = function (a, b) {
        return this.simplifyString(a).indexOf(this.simplifyString(b)) > -1;
    };
    TraderApp.prototype.addListing = function () {
        if (!this.state.addHave || !this.state.addWant || !this.state.addUser || !this.state.addZip) {
            return;
        }
        var listing = {
            want: this.state.addWant,
            have: this.state.addHave,
            zip: this.state.addZip,
            user: this.state.addUser,
            notes: this.state.addNotes || '',
            added: firebase.database['ServerValue'].TIMESTAMP
        };
        this.ref.push(listing);
        this.setOpen(false);
    };
    TraderApp.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null, React.createElement(AppBar_1.default, {title: "Pokemon Go Trader"}), React.createElement(Paper_1.default, {className: "search"}, React.createElement("h2", null, "Search for Trades"), React.createElement(AutoComplete_1.default, {floatingLabelText: "Pokemon", filter: AutoComplete_1.default.fuzzyFilter, dataSource: this.pokemon.names, maxSearchResults: 5, onUpdateInput: this.updateSearchPokemon.bind(this), onNewRequest: this.updateSearchPokemon.bind(this)}), React.createElement(AutoComplete_1.default, {floatingLabelText: "Zip", filter: AutoComplete_1.default.fuzzyFilter, dataSource: Array.from(new Set(this.state.listings.map(function (l) { return l.zip.toString(); }))), maxSearchResults: 5, onUpdateInput: this.updateSearchZip.bind(this), onNewRequest: this.updateSearchZip.bind(this)}), React.createElement(RaisedButton_1.default, {label: "Add", fullWidth: true, onClick: function () { return _this.setOpen(true); }})), React.createElement(Paper_1.default, {className: "table"}, React.createElement(Table_1.Table, {height: "calc(100vh - 400px)", fixedHeader: true}, React.createElement(Table_1.TableHeader, {displaySelectAll: false, adjustForCheckbox: false}, React.createElement(Table_1.TableRow, null, React.createElement(Table_1.TableHeaderColumn, null, "Have"), React.createElement(Table_1.TableHeaderColumn, null, "Want"), React.createElement(Table_1.TableHeaderColumn, null, "User"), React.createElement(Table_1.TableHeaderColumn, null, "Zip Code"), React.createElement(Table_1.TableHeaderColumn, null, "Notes"))), React.createElement(Table_1.TableBody, {showRowHover: true, displayRowCheckbox: false}, this.state.listings.filter(function (row, i, listings) {
            var pokemon = _this.state.pokemon;
            var zip = _this.state.zip;
            if (zip && row.zip.toString().indexOf(zip) < 0) {
                return false;
            }
            var have = _this.pokemon.list[row.have];
            var want = _this.pokemon.list[row.want];
            if (pokemon && !_this.simplifyContains(have.name, pokemon) && !_this.simplifyContains(want.name, pokemon)) {
                return false;
            }
            return true;
        }).map(function (row, i) {
            var have = _this.pokemon.list[row.have];
            var want = _this.pokemon.list[row.want];
            return (React.createElement(Table_1.TableRow, {key: i}, React.createElement(Table_1.TableRowColumn, null, React.createElement("img", {src: have.img}), have.name), React.createElement(Table_1.TableRowColumn, null, React.createElement("img", {src: want.img}), want.name), React.createElement(Table_1.TableRowColumn, null, row.user), React.createElement(Table_1.TableRowColumn, null, row.zip), React.createElement(Table_1.TableRowColumn, null, row.notes)));
        })))), React.createElement(Dialog_1.default, {title: "Add Listing", modal: true, open: this.state.add, actions: [
            React.createElement(FlatButton_1.default, {label: "Cancel", primary: true, onTouchTap: function () { return _this.setOpen(false); }}),
            React.createElement(FlatButton_1.default, {label: "Add", primary: true, onTouchTap: this.addListing.bind(this)})
        ]}, React.createElement("img", {src: this.state.addHave ? this.pokemon.list[this.state.addHave].img : ''}), React.createElement(AutoComplete_1.default, {floatingLabelText: "Have", errorText: this.state.addHave ? '' : 'Must be a Pokemon', filter: AutoComplete_1.default.fuzzyFilter, dataSource: this.pokemon.names, maxSearchResults: 5, onNewRequest: this.updateHave.bind(this), style: { width: 'calc(100% - 40px)' }}), React.createElement("img", {src: this.state.addWant ? this.pokemon.list[this.state.addWant].img : ''}), React.createElement(AutoComplete_1.default, {floatingLabelText: "Want", errorText: this.state.addWant ? '' : 'Must be a Pokemon', filter: AutoComplete_1.default.fuzzyFilter, dataSource: this.pokemon.names, maxSearchResults: 5, onNewRequest: this.updateWant.bind(this), style: { width: 'calc(100% - 40px)' }}), React.createElement(TextField_1.default, {floatingLabelText: "User", errorText: this.state.addUser ? '' : 'User required', onChange: this.updateUser.bind(this), fullWidth: true}), React.createElement(TextField_1.default, {floatingLabelText: "Zip Code", errorText: this.state.addZip ? '' : 'Zip Code required', type: "number", onChange: this.updateZip.bind(this), fullWidth: true}), React.createElement(TextField_1.default, {floatingLabelText: "Notes", onChange: this.updateNotes.bind(this), fullWidth: true, multiLine: true}))));
    };
    return TraderApp;
}(react_1.Component));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TraderApp;



/*****************
 ** WEBPACK FOOTER
 ** ./src/trader/trader.tsx
 ** module id = 592
 ** module chunks = 0
 **/